import React, { useState } from "react";
import { useMutation, useQueryClient } from "react-query";

import useRemoteTemplate from "../../../../hooks/queryResults/remote/useRemoteTemplate";
import useUrls from "../../../../hooks/useUrls";
import http from "../../../../services/httpService";
import Util from "../../../../util/util";
import Expire from "../../../ui/Expire";

export default function AdminRemotePullNowButton({ source }) {
  const template = useRemoteTemplate();
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState("");
  const { apiUrl } = useUrls();

  const mutation = useMutation(
    () => {
      const data = {};
      const url = `${apiUrl}/admin/remote/sources/${source?.id}/pull`;
      const config = Util.addTokenToHeaders();
      console.log(`sending POST request to url ${url} with data:`, data);
      return http.post(url, data, config);
    },
    {
      onSuccess: async () => {
        console.log(`source pull - mutation success`);
        const queryKey = ["admin", "remote", "sources", template?.slug];
        await queryClient.invalidateQueries(queryKey);
        await queryClient.refetchQueries(queryKey);
        setTimeout(async () => {
          console.log("fetching queries again");
          await queryClient.refetchQueries(queryKey);
        }, 5000);
      },
      onError: (error) => {
        setErrorMessage(error.response.data.error);
      },
    }
  );

  return (
    <>
      <button
        className={"btn"}
        onClick={(e) => {
          e.preventDefault();
          mutation.mutate({});
        }}
      >
        Pull
      </button>{" "}
      {mutation.isLoading ? (
        "pulling now..."
      ) : mutation.isSuccess ? (
        <Expire delay={3000}>success</Expire>
      ) : errorMessage ? (
        <span className={"alert"}>ERROR: {errorMessage}</span>
      ) : (
        ""
      )}
    </>
  );
}
